(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-tiles"] && !Shopify.designMode) return;
  try {
    
  class CategoryTiles extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
      this._onPopState = this.onPopState.bind(this);
      window.addEventListener('popstate', this._onPopState);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this._onPopState);
    }

    onClick(event) {
      const tile = event.target.closest('[data-tile-url]');
      if (!tile || !this.contains(tile)) return;
      // Let cmd/ctrl/shift-click open in a new tab as normal.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      this.swapCollection(tile.getAttribute('data-tile-url'), tile, true);
    }

    onPopState() {
      this.swapCollection(window.location.href, null, false);
    }

    getGrid() {
      // Matches Sleek's product-grid section regardless of the numeric
      // template id, which can differ per store/duplicate theme.
      return document.querySelector('[id^="shopify-section-"][id$="__product-grid"]');
    }

    async swapCollection(url, tile, pushState) {
      const grid = this.getGrid();
      if (!grid) {
        window.location.href = url;
        return;
      }

      const sectionId = grid.id.replace('shopify-section-', '');
      this.classList.add('is-loading');

      try {
        const separator = url.includes('?') ? '&' : '?';
        const response = await fetch(`${url}${separator}section_id=${sectionId}`);
        if (!response.ok) throw new Error('Request failed: ' + response.status);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.getElementById(grid.id);
        if (!newGrid) throw new Error('Section not found in response');

        grid.innerHTML = newGrid.innerHTML;

        if (pushState) history.pushState({}, '', url);

        this.querySelectorAll('[data-tile-url]').forEach((el) => {
          const isActive = tile ? el === tile : el.getAttribute('data-tile-url') === url;
          el.classList.toggle('is-active', isActive);
        });

        // Sleek's own scripts (pagination, quick view, etc.) listen for this.
        document.dispatchEvent(new CustomEvent('collection:rerendered'));

        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        // Safe fallback: never leave the user on a dead click.
        window.location.href = url;
      } finally {
        this.classList.remove('is-loading');
      }
    }
  }

  customElements.define('category-tiles', CategoryTiles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["second-image-slide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(min-width: 768px)').matches) return; // desktop keeps native hover

    function buildTrack(wrapper) {
      if (wrapper.dataset.swipeTrackReady) return;
      const imgWrapper = wrapper.querySelector('.product-card__image-wrapper');
      if (!imgWrapper) return;
      const main = imgWrapper.querySelector('.product-card__image--main');
      const second = imgWrapper.querySelector('.product-card__image--second');
      if (!main || !second) return;
      // main normally sits inside <a><motion-element>…</motion-element></a>;
      // the <a> is what makes tapping the image open the product, so the
      // track has to land inside it too, not just inside imgWrapper.
      const link = main.closest('a') || imgWrapper.querySelector('a');
      if (!link) return;

      const track = document.createElement('div');
      track.className = 'product-card__swipe-track';
      track.appendChild(main); // moves the existing element, doesn't clone
      track.appendChild(second);
      link.appendChild(track);

      wrapper.dataset.swipeTrackReady = 'true';
    }

    function processAll() {
      document.querySelectorAll('.product-card__wrapper').forEach(buildTrack);
    }

    processAll();

    // Re-run after AJAX grid updates (category buttons, filters, pagination)
    // so newly swapped-in cards get the same treatment.
    document.addEventListener('collection:rerendered', processAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
